import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getApiUrl } from '../config/api';

// Material UI
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import LinearProgress from '@mui/material/LinearProgress';

// Local
import Conversation from './Conversation';



export default function Thread() {
  const { threadId } = useParams();
  const [threads, setThreads] = useState([]);

  function getConversationMessages() {
    var api_request = new XMLHttpRequest();
    api_request.addEventListener('load', function () {
      const results = (api_request.status === 200 ? JSON.parse(this.responseText) : { 'data': {} });
      setThreads(results.threads);
    });
    api_request.open('GET', getApiUrl(`/v1/messages/thread/${threadId}?group=1`));
    api_request.withCredentials = true;
    api_request.send(null);
  }

  useEffect(() => {
    getConversationMessages();
  }, []);

  return (
    <Grid className="messages_root">
      {threads ? Object.keys(threads).map((thread) => {
        return (
          <Card>
            <Conversation threadData={threads[thread]} name={thread} id={thread} />
          </Card>
        );
      }) : <LinearProgress/>}
    </Grid>
  );
}

